var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 28.5V52.25L47.5 52.25L47.5 28.5M28.5 52.25L28.5 16.625M28.5 16.625L39.1875 16.625C40.7622 16.625 42.2725 15.9994 43.3859 14.8859C44.4994 13.7724 45.125 12.2622 45.125 10.6875C45.125 9.11278 44.4994 7.60255 43.3859 6.48905C42.2725 5.37556 40.7622 4.75 39.1875 4.75C30.875 4.75 28.5 16.625 28.5 16.625ZM28.5 16.625L17.8125 16.625C16.2378 16.625 14.7276 15.9994 13.6141 14.8859C12.5006 13.7724 11.875 12.2622 11.875 10.6875C11.875 9.11278 12.5006 7.60255 13.6141 6.48905C14.7276 5.37556 16.2378 4.75 17.8125 4.75C26.125 4.75 28.5 16.625 28.5 16.625ZM52.25 16.625L4.75001 16.625L4.75001 28.5L52.25 28.5L52.25 16.625Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.726b769f61d588ab4dd82623f751455b.svg";
export { ForwardRef as ReactComponent };